
export default function useApi(
    id: string | number,
    controller: Admin.Controllers.User
): Admin.Models.User.Api {
    return { }
}